<template>
	<div
		:class="className"
		class="relative">
		<div
			class="absolute inset-0 flex items-center"
			aria-hidden="true">
			<v-divider :soft="soft" />
		</div>

		<div class="relative flex justify-center">
			<span
				:class="backgroundClassName"
				class="px-3 text-sm text-gray-500 dark:text-gray-400">
				<slot>{{ label }}</slot>
			</span>
		</div>
	</div>
</template>

<script lang="ts">
	export default { name: 'VDividerLabel' } // name the component
</script>

<script setup lang="ts">
	// eslint-disable-next-line
	const props = defineProps({
		// matches the surface behind the divider so the label sits in a gap in the line
		backgroundClassName: {
			type: String,
			default: 'bg-white'
		},
		className: {
			type: String,
			default: ''
		},
		label: {
			type: String,
			default: ''
		},
		soft: {
			type: Boolean,
			default: false
		}
	})
</script>
